var checkAuth = function (policy, scope) {
  return (
    policy &&
    !_.includes(
      policy,
      scope.user.is_admin ||
        scope.user.role ||
        ((scope.user.distributors || [])[0] || {}).role ||
        (scope.user.manufacturer || {}).role,
    )
  );
};

var directive = function ($rootScope) {
  return {
    scope: {},
    restrict: "A",
    link: function (scope, element, attrs) {
      if (!attrs.stagedRollout) {
        return;
      }
      if (!_.get($rootScope, "rollouts." + attrs.stagedRollout)) {
        element.addClass("tizauth-hidden");
      }

      if (attrs.tizauthsr && $rootScope.policies) {
        var policy = ($rootScope.policies || {})[attrs.tizauthsr];
        if (!policy || checkAuth(policy, $rootScope)) {
          element.addClass("tizauth-hidden");
        }
      }
    },
  };
};
directive.$inject = ["$rootScope"];

tiz.directive("stagedRollout", directive);
